// Textos propis de la pàgina "ofertas" per idioma (Ofertas.jsx).

const textos = {
    es: {
        heroImageAlt: "Ofertas del Hotel Camprodon",
        heroSmallTitle: "Aprovecha nuestras ofertas",
        heroTitle: "Ofertas del Hotel Camprodon",
        stickyWidgetsButtonHref: "/buscar2",
        stickyWidgetsButtonHref2: "/restaurante#reserva-restaurant",
        presentationSmallTitle: "Ofertas del Hotel Camprodon",
        presentationTitle: "Alójate con nosotros y aprovecha nuestras ofertas",
        presentationContent: "Aquí, en nuestra web oficial, encontrarás todos los servicios del Hotel Camprodon a precios muy especiales, y además, descuentos exclusivos ¡que no encontrarás en ningún otro lugar!",
        cardContent: "Escapada de 2 noches en Camprodon los viernes y sábados desde el 7 de enero hasta el 28 de febrero (excepto el fin de semana del 13 de febrero). Incluye alojamiento, desayuno y acceso a instalaciones del hotel para disfrutar del Pirineo catalán en invierno.",
        linkHref: "/ofertas-hotel-camprodon-girona/oferta-2-noches",
        link: "Descubrir",
        buttonHref: "/buscar2",
        button: " Reservar ",
        formTitle: "¿Tienes alguna duda, consulta o sugerencia?",
        formContent: "Rellena el siguiente formulario para contactar con el Hotel Camprodon. Te responderemos a la mayor brevedad posible.",
        languageValue: "es",
        checkboxHref: "/politica-de-privacidad",
    },
    ca: {
        heroImageAlt: "Ofertes de l'Hotel Camprodon",
        heroSmallTitle: "Aprofita les nostres ofertes",
        heroTitle: "Ofertes de l'Hotel Camprodon",
        stickyWidgetsButtonHref: "/ca/buscar2",
        stickyWidgetsButtonHref2: "/ca/restaurant#reserva-restaurant",
        presentationSmallTitle: "Ofertes de l'Hotel Camprodon",
        presentationTitle: "Allotja't amb nosaltres i aprofita les nostres ofertes",
        presentationContent: "Aquí, a la nostra web oficial, trobaràs tots els serveis de l'Hotel Camprodon a preus molt especials, i a més, descomptes exclusius que no trobaràs enlloc més!",
        cardContent: <></>,
        linkHref: "/ca/ofertes-hotel-camprodon-girona/oferta-2-nits",
        link: "Descobrir",
        buttonHref: "/ca/buscar2",
        button: " Reservar ",
        formTitle: "Tens cap dubte, consulta o suggeriment?",
        formContent: "Omple el següent formulari per contactar amb l'Hotel Camprodon. Et respondrem com més aviat millor.",
        languageValue: "ca",
        checkboxHref: "/ca/politica-de-privacitat",
    },
    en: {
        heroImageAlt: "Offers at Hotel Camprodon",
        heroSmallTitle: "Take advantage of our offers",
        heroTitle: "Offers at Hotel Camprodon",
        stickyWidgetsButtonHref: "/en/buscar2",
        stickyWidgetsButtonHref2: "/en/restaurant#reserva-restaurant",
        iconAlt: "Secure reservation",
        benefitsSliderBenefit: "Secure reservation",
        iconAlt2: "Immediate confirmation",
        benefitsSliderBenefit2: "Immediate confirmation",
        presentationSmallTitle: "Camprodon Hotel Offers",
        presentationTitle: "Stay with us and take advantage of our offers",
        presentationContent: "Here you'll find out how to stay at Hotel Camprodon at very special prices, and also exclusive discounts you won't find anywhere else!",
        cardHeaderAlt: "Offer 2 nights",
        cardTitle: "Offer 2 nights",
        cardContent: <></>,
        linkHref: "/en/hotel-deals-camprodon-spain/offer-2-nights",
        link: "Find out",
        buttonHref: "/en/buscar2",
        button: " Book now ",
        formTitle: "Do you have any questions, queries or suggestions?",
        formContent: "Fill in the following form to contact the Hotel Camprodon. We will reply to you as soon as possible.",
        languageValue: "en",
        checkboxHref: "/en/privacy-policy",
        contactMethodsItem: "Through email",
    },
    fr: {
        heroImageAlt: "Offres de l'Hotel Camprodon",
        heroSmallTitle: "Profitez de nos offres",
        heroTitle: "Offres de l'Hotel Camprodon",
        stickyWidgetsButtonHref: "/fr/buscar2",
        stickyWidgetsButtonHref2: "/fr/restaurant#reserva-restaurant",
        presentationSmallTitle: "Offres de l'Hotel Camprodon",
        presentationTitle: "Séjournez chez nous et profitez de nos offres",
        presentationContent: "Ici, sur notre site officiel, vous trouverez tous les services de l'Hotel Camprodon à des prix très spéciaux, ainsi que des réductions exclusives que vous ne trouverez nulle part ailleurs !",
        cardContent: "Escapade de 2 nuits à Camprodon les vendredis et samedis du 7 janvier au 28 février (sauf le week-end du 13 février). Comprend l'hébergement, le petit-déjeuner et l'accès aux installations de l'hôtel pour profiter des Pyrénées catalanes en hiver.",
        linkHref: "/fr/offres-hotel-camprodon-espagne/offre-2-nuits",
        link: "Découvrir",
        buttonHref: "/fr/buscar2",
        button: " Réserver ",
        formTitle: "Vous avez une question, une demande ou une suggestion ?",
        formContent: "Remplissez le formulaire suivant pour contacter l'Hotel Camprodon. Nous vous répondrons dans les plus brefs délais.",
        languageValue: "fr",
        checkboxHref: "/fr/politique-de-confidentialite",
    },
    de: {
        heroImageAlt: "Angebote des Hotel Camprodon",
        heroSmallTitle: "Nutzen Sie unsere Angebote",
        heroTitle: "Angebote des Hotel Camprodon",
        stickyWidgetsButtonHref: "/de/buscar2",
        stickyWidgetsButtonHref2: "/de/restaurante#reserva-restaurant",
        presentationSmallTitle: "Angebote des Hotel Camprodon",
        presentationTitle: "Übernachten Sie bei uns und nutzen Sie unsere Angebote",
        presentationContent: "Hier auf unserer offiziellen Website finden Sie alle Leistungen des Hotel Camprodon zu besonderen Preisen und dazu exklusive Rabatte, die Sie nirgendwo sonst bekommen!",
        cardContent: "2-Nächte-Auszeit in Camprodon freitags und samstags vom 7. Januar bis 28. Februar (außer am Wochenende des 13. Februar). Inklusive Übernachtung, Frühstück und Nutzung der Hoteleinrichtungen, um die katalanischen Pyrenäen im Winter zu genießen.",
        linkHref: "/de/ofertas-hotel-camprodon-girona/oferta-2-noches",
        link: "Entdecken",
        buttonHref: "/de/buscar2",
        button: " Buchen ",
        formTitle: "Haben Sie eine Frage, ein Anliegen oder einen Vorschlag?",
        formContent: "Füllen Sie das folgende Formular aus, um das Hotel Camprodon zu kontaktieren. Wir antworten Ihnen so schnell wie möglich.",
        languageValue: "de",
        checkboxHref: "/de/privacy-policy",
    },
    it: {
        heroImageAlt: "Offerte dell'Hotel Camprodon",
        heroSmallTitle: "Approfitta delle nostre offerte",
        heroTitle: "Offerte dell'Hotel Camprodon",
        stickyWidgetsButtonHref: "/it/buscar2",
        stickyWidgetsButtonHref2: "/it/restaurante#reserva-restaurant",
        presentationSmallTitle: "Offerte dell'Hotel Camprodon",
        presentationTitle: "Soggiorna da noi e approfitta delle nostre offerte",
        presentationContent: "Qui, sul nostro sito ufficiale, troverai tutti i servizi dell'Hotel Camprodon a prezzi molto speciali e inoltre sconti esclusivi che non troverai da nessun'altra parte!",
        cardContent: "Fuga di 2 notti a Camprodon il venerdì e il sabato dal 7 gennaio al 28 febbraio (escluso il fine settimana del 13 febbraio). Include alloggio, colazione e accesso alle strutture dell'hotel per goderti i Pirenei catalani in inverno.",
        linkHref: "/it/ofertas-hotel-camprodon-girona/oferta-2-noches",
        link: "Scopri",
        buttonHref: "/it/buscar2",
        button: " Prenota ",
        formTitle: "Hai un dubbio, una domanda o un suggerimento?",
        formContent: "Compila il seguente modulo per contattare l'Hotel Camprodon. Ti risponderemo il prima possibile.",
        languageValue: "it",
        checkboxHref: "/it/informativa-sulla-privacy",
    },
    pt: {
        heroImageAlt: "Ofertas do Hotel Camprodon",
        heroSmallTitle: "Aproveite as nossas ofertas",
        heroTitle: "Ofertas do Hotel Camprodon",
        stickyWidgetsButtonHref: "/pt/buscar2",
        stickyWidgetsButtonHref2: "/pt/restaurante#reserva-restaurant",
        presentationSmallTitle: "Ofertas do Hotel Camprodon",
        presentationTitle: "Fique connosco e aproveite as nossas ofertas",
        presentationContent: "Aqui, no nosso site oficial, encontrará todos os serviços do Hotel Camprodon a preços muito especiais e, além disso, descontos exclusivos que não encontrará em mais lado nenhum!",
        cardContent: "Escapadinha de 2 noites em Camprodon às sextas e sábados de 7 de janeiro a 28 de fevereiro (exceto o fim de semana de 13 de fevereiro). Inclui alojamento, pequeno-almoço e acesso às instalações do hotel para desfrutar dos Pirenéus catalães no inverno.",
        linkHref: "/pt/ofertas-hotel-camprodon-girona/oferta-2-noches",
        link: "Descobrir",
        buttonHref: "/pt/buscar2",
        button: " Reservar ",
        formTitle: "Tem alguma dúvida, pergunta ou sugestão?",
        formContent: "Preencha o seguinte formulário para contactar o Hotel Camprodon. Responderemos o mais brevemente possível.",
        languageValue: "pt",
        checkboxHref: "/pt/politica-de-privacidade",
    },
    nl: {
        heroImageAlt: "Aanbiedingen van Hotel Camprodon",
        heroSmallTitle: "Profiteer van onze aanbiedingen",
        heroTitle: "Aanbiedingen van Hotel Camprodon",
        stickyWidgetsButtonHref: "/nl/buscar2",
        stickyWidgetsButtonHref2: "/nl/restaurante#reserva-restaurant",
        presentationSmallTitle: "Aanbiedingen van Hotel Camprodon",
        presentationTitle: "Verblijf bij ons en profiteer van onze aanbiedingen",
        presentationContent: "Hier, op onze officiële website, vind je alle diensten van Hotel Camprodon tegen heel speciale prijzen en daarnaast exclusieve kortingen die je nergens anders vindt!",
        cardContent: "Uitje van 2 nachten in Camprodon op vrijdag en zaterdag van 7 januari tot 28 februari (behalve het weekend van 13 februari). Inclusief overnachting, ontbijt en toegang tot de hotelfaciliteiten om in de winter van de Catalaanse Pyreneeën te genieten.",
        linkHref: "/nl/ofertas-hotel-camprodon-girona/oferta-2-noches",
        link: "Ontdekken",
        buttonHref: "/nl/buscar2",
        button: " Boeken ",
        formTitle: "Heb je een vraag, verzoek of suggestie?",
        formContent: "Vul het onderstaande formulier in om contact op te nemen met Hotel Camprodon. We antwoorden zo snel mogelijk.",
        languageValue: "nl",
        checkboxHref: "/nl/privacy-beleid",
    },
    cs: {
        heroImageAlt: "Nabídky hotelu Hotel Camprodon",
        heroSmallTitle: "Využijte naše nabídky",
        heroTitle: "Nabídky hotelu Hotel Camprodon",
        stickyWidgetsButtonHref: "/cs/buscar2",
        stickyWidgetsButtonHref2: "/cs/restaurante#reserva-restaurant",
        presentationSmallTitle: "Nabídky hotelu Hotel Camprodon",
        presentationTitle: "Ubytujte se u nás a využijte naše nabídky",
        presentationContent: "Zde, na našem oficiálním webu, najdete všechny služby hotelu Hotel Camprodon za velmi výhodné ceny a navíc exkluzivní slevy, které jinde nenajdete!",
        cardContent: "Pobyt na 2 noci v Camprodonu v pátek a sobotu od 7. ledna do 28. února (kromě víkendu 13. února). Zahrnuje ubytování, snídani a přístup k vybavení hotelu, abyste si užili katalánské Pyreneje v zimě.",
        linkHref: "/cs/ofertas-hotel-camprodon-girona/oferta-2-noches",
        link: "Zjistit více",
        buttonHref: "/cs/buscar2",
        button: " Rezervovat ",
        formTitle: "Máte otázku, dotaz nebo návrh?",
        formContent: "Vyplňte následující formulář a kontaktujte hotel Hotel Camprodon. Odpovíme vám co nejdříve.",
        languageValue: "cs",
        checkboxHref: "/cs/zasady-ochrany-soukromí",
    },
    ru: {
        heroImageAlt: "Предложения отеля Hotel Camprodon",
        heroSmallTitle: "Воспользуйтесь нашими предложениями",
        heroTitle: "Предложения отеля Hotel Camprodon",
        stickyWidgetsButtonHref: "/ru/buscar2",
        stickyWidgetsButtonHref2: "/ru/restaurante#reserva-restaurant",
        presentationSmallTitle: "Предложения отеля Hotel Camprodon",
        presentationTitle: "Остановитесь у нас и воспользуйтесь нашими предложениями",
        presentationContent: "Здесь, на нашем официальном сайте, вы найдёте все услуги Hotel Camprodon по особым ценам, а также эксклюзивные скидки, которых больше нигде нет!",
        cardContent: "Отдых на 2 ночи в Кампродоне по пятницам и субботам с 7 января по 28 февраля (кроме выходных 13 февраля). Включает проживание, завтрак и доступ к удобствам отеля, чтобы насладиться каталонскими Пиренеями зимой.",
        linkHref: "/ru/ofertas-hotel-camprodon-girona/oferta-2-noches",
        link: "Подробнее",
        buttonHref: "/ru/buscar2",
        button: " Забронировать ",
        formTitle: "Есть вопрос, запрос или предложение?",
        formContent: "Заполните форму ниже, чтобы связаться с Hotel Camprodon. Мы ответим вам в кратчайшие сроки.",
        languageValue: "ru",
        checkboxHref: "/ru/politika-otmeny",
    },
    sv: {
        heroImageAlt: "Erbjudanden på Hotel Camprodon",
        heroSmallTitle: "Ta del av våra erbjudanden",
        heroTitle: "Erbjudanden på Hotel Camprodon",
        stickyWidgetsButtonHref: "/sv/buscar2",
        stickyWidgetsButtonHref2: "/sv/restaurante#reserva-restaurant",
        presentationSmallTitle: "Erbjudanden på Hotel Camprodon",
        presentationTitle: "Bo hos oss och ta del av våra erbjudanden",
        presentationContent: "Här, på vår officiella webbplats, hittar du alla tjänster på Hotel Camprodon till mycket speciella priser och dessutom exklusiva rabatter som du inte hittar någon annanstans!",
        cardContent: "Miniresa 2 nätter i Camprodon fredagar och lördagar från 7 januari till 28 februari (utom helgen den 13 februari). Inkluderar boende, frukost och tillgång till hotellets faciliteter för att njuta av de katalanska Pyrenéerna på vintern.",
        linkHref: "/sv/ofertas-hotel-camprodon-girona/oferta-2-noches",
        link: "Upptäck",
        buttonHref: "/sv/buscar2",
        button: " Boka ",
        formTitle: "Har du en fråga, förfrågan eller ett förslag?",
        formContent: "Fyll i formuläret nedan för att kontakta Hotel Camprodon. Vi svarar så snart som möjligt.",
        languageValue: "sv",
        checkboxHref: "/sv/privacy-policy",
    },
};

export default textos;
